import { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { PreviewContext } from 'owa-attachment-select-actions';
import { ControlIcons } from 'owa-control-icons';
import { isFeatureEnabled } from 'owa-feature-flags';
import loc from 'owa-localize';
import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';
import ItemId from 'owa-service/lib/contract/ItemId';
import { RemoveAttachmentButtonLabel } from '../../strings.locstring.json';

export default function removeAttachmentContextMenuItemBuilder(
    attachment: AttachmentFullViewState,
    providerType?: string,
    targetWindow?: Window,
    sxsId?: string,
    isConsumer?: boolean,
    attachmentOriginalUrl?: string,
    permissionLevel?: AttachmentPermissionLevel,
    previewContext?: PreviewContext,
    parentItemId?: ItemId,
    replaceAttachmentHandler?: (
        attachmentViewState: AttachmentFullViewState,
        attachmentType: AttachmentType,
        isReadOnly: boolean,
        uploadCompleted: boolean
    ) => void,
    AttachLongPathName?: string,
    container?: HTMLElement,
    moveAttachmentToInlineHandler?: (
        attachment: AttachmentFullViewState,
        contentId: string
    ) => void,
    referenceAttachmentsSupported?: () => boolean,
    onDeleteButtonClicked?: (attachmentViewState: AttachmentFullViewState) => void
): IContextualMenuItem {
    if (attachment.isReadOnly) {
        return null;
    }

    return {
        name: loc(RemoveAttachmentButtonLabel),
        key: 'removeAttachment',
        iconProps:
            isFeatureEnabled('wvn-chicletEditOptions') ||
            isFeatureEnabled('wvn-chicletEditOptionsNoDownload')
                ? { iconName: ControlIcons.Cancel }
                : undefined,
        onClick: () => {
            logUsage('RemoveAttachmentContextMenuItemOnClick');
            onDeleteButtonClicked(attachment);
        },
    };
}
